module.exports = __webpack_public_path__ + "static/media/Greenenerg.36b0ac0a.jpg";